import styled from 'styled-components';
import { DIVIDER, GREY_100, GREY_300 } from '../../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    align-items: flex-start;
    gap: 0.5rem;
`;

export const Divider = styled.hr<{ label?: string }>`
    width: 100%;
    position: relative;
    width: 100%;
    height: 1.5rem;
    margin: 0.5rem 0;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        height: 1px;
        background-color: ${DIVIDER};
        z-index: 1;
    }

    &::after {
        ${({ label }) => label && `content: "${label}";`}
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: ${GREY_300};
        border-radius: 0.375rem;
        padding: 0 0.75rem;
        color: ${GREY_100};
        font-size: 0.875rem;
        z-index: 2;
        white-space: nowrap;
    }
`;
